<template>
  <div>
    <div class="PcDevice">
      <div class="contentBoxStatus">
        <p class="mb-2 text-center" style="font-size: 15px">
          為確保參觀者能清楚了解您的公司、產品及服務內容，請務必完成下列各個項目的資料上傳
        </p>

        <div
          class="mb-4 border text-center py-2"
          style="
            font-size: 15px;
            margin-right: 17%;
            margin-left: 17%;
            border-radius: 30px;
          "
        >
          <div class="d-flex justify-content-around">
            <a :href="`profile?no=${RegNo}`">
              <div class="d-flex align-items-center">
                <span
                  v-if="BasicinformationStatus == 1"
                  class="complete mr-1"
                ></span>
                <span v-else class="uncomplete mr-1"></span>
                <span style="color: black">基本資料 </span>
              </div>
            </a>

            <a :href="`Fascia?no=${RegNo}`" v-if="!LocalExh">
              <div class="d-flex align-items-center">
                <span v-if="FasciaStatus" class="complete mr-1"></span>
                <span v-else class="uncomplete mr-1"></span>
                <span style="color: black">招牌登錄 </span>
              </div>
            </a>

            <a :href="`Badge?no=${RegNo}`" v-if="!LocalExh">
              <div class="d-flex align-items-center">
                <span v-if="BadgeStatus" class="complete mr-1"></span>
                <span v-else class="uncomplete mr-1"></span>
                <span style="color: black">參展證 </span>
              </div>
            </a>

            <a :href="`product?no=${RegNo}`">
              <div class="d-flex align-items-center">
                <span v-if="ProductStatus !== 0" class="complete mr-1"></span>
                <span v-else class="uncomplete mr-1"></span>
                <span class="border-dark text-dark">參展產品 </span>
              </div>
            </a>

            <a :href="`Boothevent?no=${RegNo}`" v-if="LocalExh">
              <div class="d-flex align-items-center">
                <span
                  v-if="BoothEventStatus !== 0"
                  class="complete mr-1"
                ></span>
                <span v-else class="uncomplete mr-1"></span>
                <span class="border-dark text-dark">攤位活動 </span>
              </div>
            </a>

            <a :href="`news?no=${RegNo}`">
              <div class="d-flex align-items-center">
                <span
                  v-if="PressReleaseStatus !== 0"
                  class="complete mr-1"
                ></span>
                <span v-else class="uncomplete mr-1"></span>
                <span style="color: black">新聞稿 </span>
              </div>
            </a>

            <a :href="`video?no=${RegNo}`">
              <div class="d-flex align-items-center">
                <span v-if="VideoStatus !== 0" class="complete mr-1"></span>
                <span v-else class="uncomplete mr-1"></span>
                <span style="color: black">參展商影音 </span>
              </div>
            </a>

            <span v-if="showOnlineStatus">
              <a :href="`onlineExpo?no=${RegNo}`">
                <div class="d-flex align-items-center">
                  <span
                    v-if="OnlineExpolayoutStatus == 1"
                    class="complete mr-1"
                  ></span>
                  <span v-else class="uncomplete mr-1"></span>
                  <span style="color: black">線上展覽設定 </span>
                </div>
              </a>
            </span>
          </div>
        </div>
      </div>
      <div class="my-3"></div>
    </div>

    <div class="MbDevice container contentBoxStatus">
      <div class="contentBoxStatus">
        <p class="mb-3 text-center" style="font-size: 12px">
          為確保參觀者能清楚了解您的公司、產品及服務內容，請務必完成下列各個項目的資料上傳
        </p>

        <div
          class="mb-4 border text-center py-2"
          style="font-size: 12px; border-radius: 10px"
        >
          <div class="d-flex justify-content-around">
            <div>
              <a :href="`profile?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span
                      v-if="BasicinformationStatus == 1"
                      class="complete"
                    ></span>
                    <span v-else class="uncomplete"></span>
                  </div>
                </div>
                <div class="col-md-6">
                  <span style="color: black">基本資料</span>
                </div>
              </a>
            </div>
            <div v-if="!LocalExh">
              <a :href="`Fascia?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span v-if="FasciaStatus" class="complete"></span>
                    <span v-else class="uncomplete"></span>
                  </div>
                  <div class="col-md-6">
                    <span style="color: black">招牌登錄</span>
                  </div>
                </div>
              </a>
            </div>

            <div v-if="!LocalExh">
              <a :href="`Badge?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span v-if="BadgeStatus" class="complete"></span>
                    <span v-else class="uncomplete"></span>
                  </div>
                  <div class="col-md-6">
                    <span style="color: black">參展證</span>
                  </div>
                </div>
              </a>
            </div>
            <div>
              <a :href="`product?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span v-if="ProductStatus !== 0" class="complete"></span>
                    <span v-else class="uncomplete"></span>
                  </div>
                  <div class="col-md-6">
                    <span class="border-dark text-dark">產品</span>
                  </div>
                </div>
              </a>
            </div>

            <div v-if="LocalExh">
              <a :href="`Boothevent?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span v-if="BoothEventStatus !== 0" class="complete"></span>
                    <span v-else class="uncomplete"></span>
                  </div>
                  <div class="col-md-6">
                    <span class="border-dark text-dark">攤位活動</span>
                  </div>
                </div>
              </a>
            </div>

            <div>
              <a :href="`news?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span
                      v-if="PressReleaseStatus !== 0"
                      class="complete"
                    ></span>
                    <span v-else class="uncomplete"></span>
                  </div>
                  <div class="col-md-6">
                    <span style="color: black">新聞稿</span>
                  </div>
                </div>
              </a>
            </div>

            <div>
              <a :href="`video?no=${RegNo}`">
                <div class="row justify-content-center align-items-center">
                  <div class="col-md-6">
                    <span v-if="VideoStatus !== 0" class="complete"></span>
                    <span v-else class="uncomplete"></span>
                  </div>
                  <div class="col-md-6">
                    <span style="color: black">影音</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      ExhibitionCode: "",
      RegNo: "",
      //判斷各頁狀態儀表版值
      OnlineExpolayoutStatus: "",
      PressReleaseStatus: "",
      VideoStatus: "",
      ProductStatus: "",
      BasicinformationStatus: "",
      FasciaStatus: false,
      BadgeStatus: false,
      LocalExh: true,
      BoothEventStatus: "",
    };
  },

  methods: {},

  created() {
    const vm = this;

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];

    let nowPage = location.href;
    vm.getUrl = nowPage.split("ExhibitorServiceTW")[1];

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=tw`
      )
      .then((response) => {
        if (response.data.Code == 200) {
          let ExpoLocation = response.data.Data.ExpoLocation;

          if (ExpoLocation === "T" || ExpoLocation === null) {
            vm.LocalExh = true;
          } else {
            vm.LocalExh = false;
          }
        }
      });
    //儀錶板狀態

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        vm.HasOnlineExpo = response.data.Data.Virtual;

        //取得是否填寫狀態盤的值

        vm.OnlineExpolayoutStatus = response.data.Data.OnlineExpolayoutStatus;
        vm.PressReleaseStatus = response.data.Data.PressReleaseStatus;
        vm.VideoStatus = response.data.Data.VideoStatus;
        vm.ProductStatus = response.data.Data.ProductStatus;
        vm.BoothEventStatus = response.data.Data.BoothEventStatus;

        vm.BasicinformationStatus = response.data.Data.BasicinformationStatus;
        vm.BadgeStatus = response.data.Data.HasBadge;
        vm.FasciaStatus = response.data.Data.HasFascia;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/RegNoCheck/${vm.RegNo}?lang=tw`
      )
      .then((response) => {
        // console.log(response.data.Data)

        vm.ExhibitionCode = response.data.Data.ExhibitionCode;
      });
  },
};
</script>

<style lang="scss">
.uncomplete {
  background-image: url("../assets/images/tickGray.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.complete {
  background-image: url("../assets/images/tick.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}
</style>
